<template>
  <div class="register animated bounceInRight">
    <span class="iconfont icon-fanhui back" @click="$router.go(-1)"></span>
    <h2 class="welcome">注册</h2>
    <div class="usermsg">
      <div class="msgList">
        <span class="iconfont icon-dianhua-"></span>
        <van-field v-model="phone" type="tel" placeholder="请输入手机号" clearable />
      </div>

      <div class="msgList">
        <span class="icon-baohu iconfont"></span>
        <van-field v-model="code" clearable placeholder="请输入验证码" />
        <span class="red" @click="getCode" v-if="codeFlag">获取验证码</span>
        <span class="red" style="min-width: 130px;" v-if="!codeFlag">({{currentS}})秒后重新获取</span>
      </div>

      <div class="msgList">
        <span class="icon-mima iconfont"></span>
        <van-field v-model="pass" clearable type="password" placeholder="8-16位密码(数字，大小写字母的组合)" />
      </div>
    </div>

    <div class="edit_btn">
      <van-button type="danger" round class="register_btn" size="small" @click="register">注册账号</van-button>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
export default {
  data() {
    return {
      phone: "",
      code: "",
      pass: "",
      codeFlag: true,
      currentS: 60,
      appName: this.appName
    };
  },
  mounted(){
      this.currentS = 60;
  },
  methods: {
    sendCode(){
      this.codeFlag = !this.codeFlag;
      this.currentS = 60;
      var timeId = setInterval(() => {
        this.currentS--;
        if (this.currentS == 0) {
          this.codeFlag = !this.codeFlag;
          clearInterval(timeId)
          return;
        }
      }, 1000);
      this.$http.get(this.javalinkTwo + `app/ap_member//auth/sendVerificationCode?phone=${this.phone}`).then(res=>{
        // console.log(res);
        if(res.data.code===3007){
          Toast("获取验证码成功")
        }else{
          Toast(res.data.message)
        }
      }).catch(err=>{
        // console.log(err)
        Toast("请检查网络是否可用")
      })
    },
    //获取验证码
    getCode() {
      if (!this.phone) {
        Toast("请输入手机号");
        return;
      }
      if (this.phone.length != 11) {
        Toast("手机号输入有误");
        return;
      }
      // 判断用户手机号是否注册
     this.$http.get(this.javalinkTwo + `app/ap_member//member/query/check/phone?appName=${this.appName}&phone=${this.phone}`).then(res=>{
      //  console.log('验证');
      //  console.log(res);
       if(res.data.code===10000){
         if(res.data.data == true){
            Toast("该手机号已经注册过了")
            return
         }else{
           this.sendCode();
         }
       }
     })
      
    },
    registerSubmit(){
      if(this.pass.length>20 || this.pass.length <6){
        Toast("请输入8-16位密码(数字，大小写字母的组合)");
        return
      }
       const data = {
          appName: this.appName,
          code: this.code,
          password: this.pass,
          phone: this.phone
      };
      // console.log(data);
      this.$http
        .post(this.javalinkTwo + `app/ap_member//member/add/register_account`, data)
        .then(res => {
          // console.log(res);
          if (res.data.code === 10000) {
            Toast("注册成功");
            // localStorage.userMsg = JSON.stringify({
            //   username:this.phone,
            //   password:this.pass
            // })
            setTimeout(() => {
              this.$router.go(-1);
            }, 1000);
          } else {
            Toast(res.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          Toast("注册失败，请联系管理员");
        });
    },
    register() {
      if(!this.phone || this.phone.length !=11){
        Toast("请正确输入手机号")
        return
      }
      if(!this.code){
        Toast("请输入验证码")
        return
      }
      if (!this.pass) {
        Toast("请输入密码")
      }
      // 验证码验证
      this.$http.get(this.javalinkTwo + `app/ap_member//auth/verificationCodeIsTrue?phone=${this.phone}&code=${this.code}`).then(res=>{
        console.log(res.data);
        if(res.data.code === 10000){
            // 验证成功
            this.registerSubmit();
        }else{
          Toast("验证码错误")
        }
      }).catch(err=>{
        console.log(err)
      })
     
    }
  }
};
</script>

<style lang="less">
.register {
  padding: 0 20px;
  box-sizing: border-box;
  .back {
    font-size: 20px;
    position: absolute;
    left: 10px;
    top: 40px;
  }
  .red {
    color: #e42417;
    float: right;
    min-width: 100px;
    text-align: center;
  }
  .edit_btn {
    margin: 30px auto 0;
    display: flex;
    justify-content: center;
    .register_btn {
      padding: 0 30px;
      font-size: 16px;
    }
  }
  .usermsg {
    margin-top: 45px;
    padding: 0 15px;
    box-sizing: border-box;
    .msgList {
      display: flex;
      justify-content: left;
      align-items: center;
      border-bottom: 1px solid #eee;
    }
  }
  .welcome {
    font-size: 20px;
    font-weight: 700;
    margin-top: 80px;
  }
}
</style>